import React from "react";
import video from "../../../assets/homepage_video.mp4";

//style
import styles from "../CSS/homepage_video.module.css";

const backgroundVideo = () => (
	<video
		className={styles.video}
		autoPlay
		width="100%"
		height="100%"
		muted
		loop
	>
		<source src={video} type="video/mp4" />
	</video>
);

export default backgroundVideo;
